import {
  AUCTION_ITEM,
  FIXED_PRICE_ITEM,
  getDefaultItemDisplayOrder,
  getInitialItemDisplayOrder,
  getOrderEntryKey,
} from '../components/utils'

export {
  AUCTION_ITEM,
  FIXED_PRICE_ITEM,
  getDefaultItemDisplayOrder,
  getInitialItemDisplayOrder,
  getOrderEntryKey,
}

export const shouldShowArrangeDisplayOrder = (auction) => (
  (Array.isArray(auction?.Items) ? auction.Items.length : 0)
  + (Array.isArray(auction?.FixedItems) ? auction.FixedItems.length : 0)
  >= 2
)

export const itemDisplayOrdersMatch = (firstOrder, secondOrder) => (
  firstOrder.length === secondOrder.length
  && firstOrder.every((entry, index) => (
    entry.ItemType === secondOrder[index].ItemType
    && entry.ItemId === secondOrder[index].ItemId
  ))
)

const compareText = (firstValue, secondValue) => (
  (firstValue || '').localeCompare(secondValue || '', undefined, {
    numeric: true,
    sensitivity: 'base',
  })
)

const getSortableItems = (auction) => [
  ...(auction?.Items || []).map((item) => ({
    ItemType: AUCTION_ITEM,
    ItemId: item.ItemId,
    item,
  })),
  ...(auction?.FixedItems || []).map((item) => ({
    ItemType: FIXED_PRICE_ITEM,
    ItemId: item.FixedItemId,
    item,
  })),
]

const compareItemType = (firstEntry, secondEntry) => {
  if (firstEntry.ItemType === secondEntry.ItemType) return 0
  return firstEntry.ItemType === AUCTION_ITEM ? -1 : 1
}

const compareTitle = (firstEntry, secondEntry) => (
  compareText(firstEntry.item.Title, secondEntry.item.Title)
  || compareItemType(firstEntry, secondEntry)
  || compareText(firstEntry.ItemId, secondEntry.ItemId)
)

const getCategory = (entry) => entry.item.Category?.trim() || ''

const categoryIsNotApplicable = (category) => (
  category === '' || category.toLocaleLowerCase() === 'n/a'
)

const compareCategory = (firstEntry, secondEntry) => {
  const firstCategory = getCategory(firstEntry)
  const secondCategory = getCategory(secondEntry)
  const firstIsNotApplicable = categoryIsNotApplicable(firstCategory)
  const secondIsNotApplicable = categoryIsNotApplicable(secondCategory)

  if (firstIsNotApplicable !== secondIsNotApplicable) return firstIsNotApplicable ? 1 : -1
  if (firstIsNotApplicable) return compareTitle(firstEntry, secondEntry)

  return compareText(firstCategory, secondCategory) || compareTitle(firstEntry, secondEntry)
}

export const sortItemsByPreset = (auction, preset) => {
  const sortableItems = getSortableItems(auction)

  if (preset === 'type') {
    sortableItems.sort((firstEntry, secondEntry) => (
      compareItemType(firstEntry, secondEntry) || compareTitle(firstEntry, secondEntry)
    ))
  } else if (preset === 'category') {
    sortableItems.sort(compareCategory)
  } else if (preset === 'title') {
    sortableItems.sort(compareTitle)
  }

  return sortableItems.map(({ ItemType, ItemId }) => ({ ItemType, ItemId }))
}
